
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workout/[slug]",
      function () {
        return require("private-next-pages/workout/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workout/[slug]"])
      });
    }
  